/* filter data for shipment */


export const namespaced = true

export const state = {
    agent_id_list:[],
    filter_date_from : "",
    filter_date_to : "",
    filter_count:0,
}

export const mutations = {
    SET_PAYOUT_FILTER(state, {
        agent_id_list,
        filter_date_from,
        filter_date_to,
        filter_count,
    }) {
        state.agent_id_list = agent_id_list
        state.filter_date_from = filter_date_from
        state.filter_date_to = filter_date_to
        state.filter_count = filter_count
    },
}
export const actions = {
    setPayoutFilter({
        commit
    }, items) {
        commit('SET_PAYOUT_FILTER', items)
    },
}
export const getters = {
    getPayoutFilter: state => {
        return state;
    },
}